import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./getters"
import user from "./modules/user"
//挂载vuex
Vue.use(Vuex)

//初始化vuex
const store = new Vuex.Store({
  modules: {
    user
  },
  getters,
  /*state: {
    count: 0
  },

  mutations: {
    increment (state) {
      state.count++
    },
    sub (state) {
      state.count--
    }
  },
  actions: {
    incr({commit}){
      commit('increment')
    }
  }*/
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js